import { webCollaborationMessages } from 'azshared';
import React from 'react';
import { useIntl } from 'react-intl';
import { AppButtonIcon } from '../button-icon/app-button-icon';
import { AppDialog } from '../dialog/app-dialog';
import './web-collaboration-sharing-block-dialog.scss';

interface WebCollaborationSharingBlockDialogProps {
  open: boolean;
  onSharing: () => void;
}

export const WebCollaborationSharingBlockDialog = (props: WebCollaborationSharingBlockDialogProps) => {
  const { formatMessage } = useIntl();

  return (
    <AppDialog open={props.open} className='web-collaboration-sharing-block-dialog-wrapper'>
      <div className='web-collaboration-sharing-block-dialog'>
        <div className='web-collaboration-sharing-block-dialog-section'>
          <p className='web-collaboration-sharing-block-dialog-content'>{formatMessage(webCollaborationMessages.sharingBlockDialog)}</p>
        </div>
        <div className='web-collaboration-sharing-block-dialog-button-section'>
          <AppButtonIcon
            icon='share-video-on'
            className='web-collaboration-sharing-block-dialog-icon-button'
            labelClassName='web-collaboration-sharing-block-dialog-icon-button-label'
            iconClassName='web-collaboration-sharing-block-dialog-icon-button-icon'
            label={formatMessage(webCollaborationMessages.sharedVideoButton)}
            onClick={props.onSharing}
          />
        </div>
      </div>
    </AppDialog>
  );
};
